<template>
  <div class="filters">
    <div class="row" v-show="isFullPage">
      <div class="col-md-4 col-lg-3 date-range-type">
        <multiselect v-model="filters.date_type_filter"
                     track-by="id"
                     id="date-type-option"
                     label="name"
                     :options="dateRangeSelector"
                     :placeholder="$t('multiselect.placeholder')"
                     :showLabels="true"
                     :allow-empty="true"
                     deselectLabel="X"
                     selectedLabel="X"
                     selectLabel=""
                     @input="addFilterDateRangeType"
                     class="arrow-multiselect">
        </multiselect>
      </div>
    </div>

    <div class="row pt-3 pb-1" v-show="isFullPage">
      <div class="col-md-6 col-lg-4 label-filter-date label-input-filter">
        {{ $t("stats.offers_between") }}
      </div>
      <div class="col-md-6 col-lg-3">
        <date-picker-filter v-model="filters.start_at_gteq"
                     id="start_at_gteq"
                     :beginningOfDay="true"
                     :allDate="true"
                     @input="addFilter"/>
      </div>

      <div class="col-md-6 col-lg-1 label-filter-date label-input-filter">
        et le
      </div>

      <div class="col-md-6 col-lg-3">
        <date-picker-filter v-model="filters.start_at_lteq"
                     id="start_at_lteq"
                     :endOfDay="true"
                     :allDate="true"
                     @input="addFilter"/>
      </div>
    </div>

    <SharedFilters @change="onChangeSharedFilters"></SharedFilters>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import DatePickerFilter from '@/components/pages/DatePickerFilter'
  import ie_mixin from '@/mixin/ie'
  import stats_mixin from '@/mixin/stats'
  import moment from 'moment'
  import SharedFilters from "./shared/Filters";

  export default {
    name: 'Filters',
    data() {
      return {
        filters: {
          replaced_occupation_id_in: '',
          replaced_service_id_in: '',
          hub_id_in: '',
          entity_id_in: null,
          date_type_filter: '',
          start_at_gteq: '',
          start_at_lteq: ''
        },
        datepickerDefaultOptions: {
          startDate: new Date(2018, 1, 1)
        },
        dateRangeSelector: this.functionDateRangeSelector(),
      }
    },
    mixins: [ie_mixin, stats_mixin],
    components: {DatePickerFilter, SharedFilters},
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
        isFullPage: 'stats/isFullPage',
        servicesOptions: 'users/manageableServices',
        occupationsOptions: 'users/manageableOccupations',
        entitiesOptions: 'users/manageableEntities',
        isSingleEntity: 'auth/isSingleEntity',
        filters_display: 'stats/filters_display'
      }),
      string_filters() {
        return JSON.stringify(this.filters)
      }
    },
    methods: {
      ...mapActions({
        setStateFilter: 'stats/setStateFilter'
      }),
      onChangeSharedFilters(filterParams) {
        if(filterParams['id'] == 'entity_id_in') {
          this.resetSelected()
        }
        this.filters[filterParams['id']] = filterParams['value'];
      },
      addFilter: function (value, id) {
        if (this.filters[id] !== value) {
          this.filters.date_type_filter = '';
          this.filters[id] = value
        }
      },
      addFilterDateRangeType: function (value) {
        if (value === null) {
          this.filters.date_type_filter = '';
        }

        this.filters['start_at_gteq'] = value && value['start_at_gteq'];
        this.filters['start_at_lteq'] = value && value['start_at_lteq'];
      },
      functionDateRangeSelector: function () {
        let format = 'DD/MM/YYYY';

        let startFollowingMonth = moment().add(1, 'month').startOf('month').format(format);
        let endFollowingMonth = moment().add(1, 'month').endOf('month').format(format);

        let startCurrentMonth = moment().startOf('month').format(format);
        let endCurrentMonth = moment().endOf('month').format(format);

        let startLastMonth = moment().add(-1, 'month').startOf('month').format(format);
        let endLastMonth = moment().add(-1, 'month').endOf('month').format(format);

        let startLastQuarter = moment().add(-1, 'quarter').startOf('quarter').format(format);
        let endLastQuarter = moment().add(-1, 'quarter').endOf('quarter').format(format);

        let startLastYear = moment().add(-1, 'year').startOf('year').format(format);
        let endLastYear = moment().add(-1, 'year').endOf('year').format(format);

        let name_next_month = this.$t('Statistic.filters.date_range_types.next_month');
        let name_current_month = this.$t('Statistic.filters.date_range_types.current_month');
        let name_last_month = this.$t('Statistic.filters.date_range_types.last_month');
        let name_last_quarter = this.$t('Statistic.filters.date_range_types.last_quarter');
        let name_last_year = this.$t('Statistic.filters.date_range_types.last_year');
        return [
          {'id': 1, 'name': name_next_month, start_at_gteq: startFollowingMonth, start_at_lteq: endFollowingMonth},
          {'id': 2, 'name': name_current_month, start_at_gteq: startCurrentMonth, start_at_lteq: endCurrentMonth},
          {'id': 3, 'name': name_last_month, start_at_gteq: startLastMonth, start_at_lteq: endLastMonth},
          {'id': 4, 'name': name_last_quarter, start_at_gteq: startLastQuarter, start_at_lteq: endLastQuarter},
          {'id': 5, 'name': name_last_year, start_at_gteq: startLastYear, start_at_lteq: endLastYear}
        ]
      },
      resetSelected: function () {
        this.filters.replaced_occupation_id_in = '';
        this.filters.replaced_service_id_in = '';
        this.filters.hub_id_in = '';
      },
      getFilterStats() {
        this.$store.dispatch("stats/getCompletionOfRequestsStats", {filters: this.filters});
        this.$store.dispatch("stats/getResponseByTimeStats", {filters: this.filters});
        this.$store.dispatch("stats/getOffersByServicesStats", {filters: this.filters});
        this.$store.dispatch("stats/getOffersByEntitiesStats", {filters: this.filters});
        this.$store.dispatch("stats/getOffersByOccupationsStats", {filters: this.filters});
        this.$store.dispatch("stats/getOffersByHubsStats", {filters: this.filters});
        this.$store.dispatch("stats/getReasonsReplacement", {filters: this.filters});
        this.$store.dispatch("stats/topCandidates", {filters: this.filters});
      }
    },
    watch: {
      string_filters: {
        handler: function (new_filters, old_filters) { 
          let new_filters_json = JSON.parse(new_filters);
          if (old_filters === new_filters ||
              (new_filters_json.entity_id_in === null && this.isSingleEntity)
          ) {
            return false;
          }
          let hubIds = this.filters.hub_id_in;
          if (this.isSingleEntity) {
            this.$store.dispatch('users/initManageableOptions', { hubIds: hubIds });
          } else {
            let entityId = this.filters.entity_id_in
            if(entityId && hubIds.length === 0) {
              this.$store.dispatch('users/initManageableOptions', { entityId: entityId });
            } else if (hubIds.length !== 0) {
              this.$store.dispatch('users/initManageableOptions', { entityId: entityId, hubIds: hubIds });
            }
          }
          this.getFilterStats();
        },
        deep: true
      },
      filters_display: {
        handler: function (new_filters) {
          this.listFilterId(this.filters, new_filters)
        },
        deep: true
      }
    },
    mounted: function () {
      let defaultFilter = this.functionDateRangeSelector()[1];
      this.filters['date_type_filter'] = defaultFilter;
      this.filters['start_at_gteq'] = defaultFilter['start_at_gteq'];
      this.filters['start_at_lteq'] = defaultFilter['start_at_lteq'];
    }
  }
</script>

<style type="text/scss">
  .filters {
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/Filters.vue